import comp0 from '@/app/accountpage'
import comp1 from '@/app/checkoutsuccess'
import comp2 from '@/app/checkout'
import comp3 from '@/app/shoplist'
import comp4 from '@/app/dialog'
import comp5 from '@/app/loaderglobal'
import comp6 from '@/app/cookieconsent'
import comp7 from '@/app/cookiebanner'
import comp8 from '@/app/orderboxoverlay'
import comp9 from '@/app/sentry'
import comp10 from '@/app/collapsible'
import comp11 from '@/app/qrcode'
import comp12 from '@/app/marquee'
import comp13 from '@/app/formsubmit'
import comp14 from '@/app/countdown'
import comp15 from '@/app/courseform'
import comp16 from '@/app/donationinput'
import comp17 from '@/app/freeproducts'
import comp18 from '@/app/bgvideo'
import comp19 from '@/app/scrollto'
import comp20 from '@/app/contentslider'
import comp21 from '@/app/locationdetailbuttons'
import comp22 from '@/app/locationgooglerating'
import comp23 from '@/app/locations'
import comp24 from '@/app/toggleoverlay'
import comp25 from '@/app/loginform'
import comp26 from '@/app/registerconfirm'
import comp27 from '@/app/registerform'
import comp28 from '@/app/selforderinglogin'
import comp29 from '@/app/migrationverify'
import comp30 from '@/app/migration'
import comp31 from '@/app/orderfeedback'
import comp32 from '@/app/outdoordelivery'
import comp33 from '@/app/paymentfallback'
import comp34 from '@/app/productpublic'
import comp35 from '@/app/reservationpage'
import comp36 from '@/app/imageslider'
import comp37 from '@/app/statscounter'
import comp38 from '@/app/surveyform'
import comp39 from '@/app/video'
import comp40 from '@/app/vouchersbalance'
import comp41 from '@/app/vouchersbuy'
import comp42 from '@/app/vouchersreload'
import comp43 from '@/app/header'
import comp44 from '@/app/navmeta'
import comp45 from '@/app/loginregisteroverlay'
import comp46 from '@/app/sidebarcart'
import comp47 from '@/app/orderbox'
import comp48 from '@/app/message'
import comp49 from '@/app/passwordresetform'
import comp50 from '@/app/togglesubmenu'
import comp51 from '@/app/referralwidget'
var map={}; 
map['app/accountpage']=comp0;
map['app/checkoutsuccess']=comp1;
map['app/checkout']=comp2;
map['app/shoplist']=comp3;
map['app/dialog']=comp4;
map['app/loaderglobal']=comp5;
map['app/cookieconsent']=comp6;
map['app/cookiebanner']=comp7;
map['app/orderboxoverlay']=comp8;
map['app/sentry']=comp9;
map['app/collapsible']=comp10;
map['app/qrcode']=comp11;
map['app/marquee']=comp12;
map['app/formsubmit']=comp13;
map['app/countdown']=comp14;
map['app/courseform']=comp15;
map['app/donationinput']=comp16;
map['app/freeproducts']=comp17;
map['app/bgvideo']=comp18;
map['app/scrollto']=comp19;
map['app/contentslider']=comp20;
map['app/locationdetailbuttons']=comp21;
map['app/locationgooglerating']=comp22;
map['app/locations']=comp23;
map['app/toggleoverlay']=comp24;
map['app/loginform']=comp25;
map['app/registerconfirm']=comp26;
map['app/registerform']=comp27;
map['app/selforderinglogin']=comp28;
map['app/migrationverify']=comp29;
map['app/migration']=comp30;
map['app/orderfeedback']=comp31;
map['app/outdoordelivery']=comp32;
map['app/paymentfallback']=comp33;
map['app/productpublic']=comp34;
map['app/reservationpage']=comp35;
map['app/imageslider']=comp36;
map['app/statscounter']=comp37;
map['app/surveyform']=comp38;
map['app/video']=comp39;
map['app/vouchersbalance']=comp40;
map['app/vouchersbuy']=comp41;
map['app/vouchersreload']=comp42;
map['app/header']=comp43;
map['app/navmeta']=comp44;
map['app/loginregisteroverlay']=comp45;
map['app/sidebarcart']=comp46;
map['app/orderbox']=comp47;
map['app/message']=comp48;
map['app/passwordresetform']=comp49;
map['app/togglesubmenu']=comp50;
map['app/referralwidget']=comp51;
export default map;